/**
 * Labels of UI
 * @author: adalto.junior
 * Date: 22/11/13
 * Time: 14:20
 */



Monet.UI = Monet.UI || {};

Monet.UI.Label = function () {

    this.label = document.createElement('div');

    this.setContent = function (content) {

        if (this.label) {

            this.label.innerHTML = content;
        }
    };

    this.removeFromParentNode = function () {

        var parentNode = null;

        if (this.label) {

            parentNode = this.label.parentNode;

            if (parentNode) {
                parentNode.removeChild(this.label);
            }

        }

    };

    this.destroy = function () {


        if (this.label) {

            this.removeFromParentNode();

            this.label = null;
        }

    };

    this.render = function () {

        return this.label;

    };

};

Monet.UI.Label.Notification = (function () {

    function Notification(){

        Monet.UI.Label.apply(this, arguments);

        this.render = function () {

            this.label.className = 'MonetUILabelNotification';

            return this.label;

        };

    }

    return Notification;

}());

